import { fmtSize, fmtDate } from './nasApi';
import NasOpenLocation, { CopyPathButton } from './NasOpenLocation';

// NAS file list (table). Independent of the DMS list; read-only.
// `showLocation` adds the per-row「元の場所を開く」action used in search results.
export default function NasFileList({ files, onOpen, showLocation = false }) {
  return (
    <div className="rounded-lg border border-zinc-200 bg-white overflow-hidden" data-testid="nas-file-list">
      <table className="w-full text-sm">
        <thead className="bg-zinc-100 text-zinc-700 text-xs">
          <tr>
            <th className="text-left px-3 py-2 font-semibold">ファイル名</th>
            <th className="text-left px-2 py-2 font-semibold hidden md:table-cell">NASパス</th>
            <th className="text-right px-2 py-2 font-semibold">サイズ</th>
            <th className="text-left px-3 py-2 font-semibold hidden sm:table-cell">更新</th>
            {showLocation && <th className="px-2 py-2 font-semibold text-right">場所</th>}
          </tr>
        </thead>
        <tbody>
          {files.map((f) => {
            const full = f.full_path || f.logical_path;
            return (
              <tr key={f.node_id} onClick={() => onOpen(f)}
                className="border-t border-zinc-200 hover:bg-teal-50/40 cursor-pointer"
                data-testid={`nas-file-row-${f.node_id}`}>
                <td className="px-3 py-2 font-medium text-zinc-800 truncate max-w-[280px]"
                  title={f.name}>{f.name}</td>
                <td className="px-2 py-2 text-zinc-400 truncate max-w-[320px] hidden md:table-cell"
                  title={full} data-testid={`nas-file-path-${f.node_id}`}>{full}</td>
                <td className="px-2 py-2 text-right text-zinc-400 tabular-nums">{fmtSize(f.size)}</td>
                <td className="px-3 py-2 text-zinc-400 hidden sm:table-cell">{fmtDate(f.modified)}</td>
                {showLocation && (
                  <td className="px-2 py-2 text-right whitespace-nowrap">
                    <CopyPathButton value={full} label="NASパスをコピー"
                      testid={`nas-copy-row-${f.node_id}`} />
                    <NasOpenLocation nodeId={f.node_id} compact />
                  </td>
                )}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
